module.exports = __webpack_public_path__ + "img/logo_entreprise.c8534d17.png";